export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
            关于我们
          </h2>
          <div className="w-16 h-1 bg-primary-500 mx-auto mb-8 rounded-full"></div>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            韩国漫画网站是一个专注于韩国漫画资源整合与导航的综合性平台。我们深知韩国漫画爱好者在海量信息中寻找优质资源的困扰，因此致力于打造最全面、最及时的韩国漫画网站大全。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            从NAVER Webtoon到Kakao Page，从热门连载到经典完结，我们持续追踪各大韩国漫画网的最新动态，为读者提供免费韩国漫画网站推荐、人气排行、新作速递等实用信息。我们的编辑团队每日更新内容，确保每一位访问者都能第一时间获取最有价值的韩国漫画资讯。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            无论您是资深韩国漫画迷，还是刚刚入门的新读者，韩国漫画网站都将是您探索韩国漫画世界的最佳入口和最可靠伙伴。
          </p>
        </div>
      </div>
    </section>
  );
}